import React from "react"
import { StyledImg } from "./PageHero.styles"

const PageHero = ({ img }) => <StyledImg image={img} alt="Page Hero" />

export default PageHero
